var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['layout-view', _vm.offset]},[(this.$route.params.farm_id && this.$route.params.farm_id !== '-1')?_c('controls-panel'):_vm._e(),_c('farm-panel',{on:{"farm-selected":_vm.onFarmSelected}}),_c('mixers-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }